export default [
  {
    value: 'name',
    text: 'Название',
    type: 'string',
    description: ''
  },
  {
    value: 'description',
    text: 'Описание',
    type: 'string',
    description: ''
  },
  {
    value: 'isProtected',
    text: 'Защищен',
    width: 60,
    type: 'boolean',
    description: ''
  },
  {
    value: 'permissions',
    text: 'Кол-во разрешений',
    width: 160,
    type: 'amount',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
